// Lazy PostHog initializer gated by cookie consent (Phase 2.6).
import { getConsent } from "./consent";

let initialized = false;

export async function maybeInitAnalytics() {
  if (initialized) return;
  const consent = getConsent();
  if (!consent?.analytics) return;

  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;

  try {
    const posthog = (await import("posthog-js")).default;
    posthog.init(key, {
      api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
      person_profiles: "identified_only",
      capture_pageview: true,
      // WO-53 (BILAL 30/09/2026): screen recording would copy CRM screens to
      // PostHog. Off in code, whatever the PostHog project setting says.
      // Page views and clicks (capture_pageview) stay.
      disable_session_recording: true,
    });
    window.posthog = posthog;
    initialized = true;
  } catch (e) {
    // swallow: analytics must never break the app
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("PostHog init failed", e);
    }
  }
}

export function optOutAnalytics() {
  try {
    if (window.posthog) {
      window.posthog.opt_out_capturing?.();
      window.posthog.reset?.();
    }
    // Remove any ph_* cookies
    document.cookie
      .split(";")
      .map((c) => c.trim().split("=")[0])
      .filter((n) => n.startsWith("ph_"))
      .forEach((n) => {
        document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      });
  } catch {
    /* no-op */
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("mid2bid:consent", () => {
    const c = getConsent();
    if (c?.analytics) {
      maybeInitAnalytics();
    } else {
      optOutAnalytics();
    }
  });
}
